import * as actionTypes from './../Register_action.types';
import * as api from './../register_api_services/MaternityBenefits.api';


export const getmaternityBenefitsRequest = () => ({
  type: actionTypes.GET_MATERNITY_BENEFITS_REQUEST,
});

export const getmaternityBenefitsSuccess = (maternity) => ({
  type: actionTypes.GET_MATERNITY_BENEFITS_SUCCESS,
  payload: maternity,
});

export const getmaternityBenefitsFailure = (error) => ({
  type: actionTypes.GET_MATERNITY_BENEFITS_FAILURE,
  payload: error,
});

export const getMaternityBenefits = (date) => {
  return async (dispatch) => {
    dispatch(getmaternityBenefitsRequest(date));
    try {
      const leaves = await api.fetchMaternityBenefitsData(date);
      dispatch(getmaternityBenefitsSuccess(leaves));
      return { success: true, data: leaves };
    } catch (error) {
      dispatch(getmaternityBenefitsFailure(error));
      return { success: false, message: error };
    }
  };
};

export const updatematernityBenefitsRequest = (id, maternityData) => ({
  type: actionTypes.UPDATE_MATERNITY_BENEFITS_REQUEST,
  payload: { id, maternityData },
});

export const updatematernityBenefitsSuccess = (message) => ({
  type: actionTypes.UPDATE_MATERNITY_BENEFITS_SUCCESS,
  payload: message,
});

export const updatematernityBenefitsFailure = (error) => ({
  type: actionTypes.UPDATE_MATERNITY_BENEFITS_FAILURE,
  payload: error,
});

export const updateMaternityBenefitsById = (id, maternityData) => {
  return async (dispatch) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    maternityData.updated_by = user.user_name;

    dispatch(updatematernityBenefitsRequest(id, maternityData));
    try {
      const response = await api.updateMaternityBenefits(id, maternityData);
      dispatch(updatematernityBenefitsSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(updatematernityBenefitsFailure(error));
      return { success: false, message: error };
    }
  };
};




export const deletematernityBenefitsRequest = (id) => ({
  type: actionTypes.DELETE_MATERNITY_BENEFITS_REQUEST,
  payload: id,
});

export const deletematernityBenefitsSuccess = (message) => ({
  type: actionTypes.DELETE_MATERNITY_BENEFITS_SUCCESS,
  payload: message,
});

export const deleteaternityBenefitsFailure = (error) => ({
  type: actionTypes.DELETE_MATERNITY_BENEFITS_FAILURE,
  payload: error,
});

export const deleteMaternityBenefitsById = (id) => {
  return async (dispatch) => {
    dispatch(deletematernityBenefitsRequest(id));
    try {
      const response = await api.deleteMaternityBenefits(id);
      dispatch(deletematernityBenefitsSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(deleteaternityBenefitsFailure(error));
      return { success: false, message: error };
    }
  };
};


export const uploadMaternityBenefitsRequest = (fileData) => ({
  type: actionTypes.UPLOAD_MATERNITY_BENEFITS_REQUEST,
  payload: fileData,
});

export const uploadMaternityBenefitsSuccess = (message) => ({
  type: actionTypes.UPLOAD_MATERNITY_BENEFITS_SUCCESS,
  payload: message,
});

export const uploadMaternityBenefitsFailure = (error) => ({
  type: actionTypes.UPLOAD_MATERNITY_BENEFITS_FAILURE,
  payload: error,
});

export const uploadMaternityBenefitsFile = (fileData) => {
  return async (dispatch) => {
    dispatch(uploadMaternityBenefitsRequest(fileData));
    try {
      const response = await api.maternityBenefitsUpload(fileData);
      dispatch(uploadMaternityBenefitsSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(uploadMaternityBenefitsFailure(error));
      const errorMessage = error?.response?.data?.error || error?.message || 'Upload failed';
      return { success: false, error: errorMessage };
    }
  };
};

export const multiDaleteMaternityBenefitsRequest = (ids) => ({
  type: actionTypes.MULTIDELETE_MATERNITY_BENEFITS_REQUEST,
  payload: ids,
});

export const multiDaleteMaternityBenefitsSuccess = (message) => ({
  type: actionTypes.MULTIDELETE_MATERNITY_BENEFITS_SUCCESS,
  payload: message,
});

export const multiDaleteMaternityBenefitsFailure = (error) => ({
  type: actionTypes.MULTIDELETE_MATERNITY_BENEFITS_FAILURE,
  payload: error,
});

export const multiDeleteMaternityBenefits = (ids) => {
  return async (dispatch) => {
    dispatch(multiDaleteMaternityBenefitsRequest(ids));
    try {
      const response = await api.multiDeleteMaternityBenefits(ids);
      dispatch(multiDaleteMaternityBenefitsSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(multiDaleteMaternityBenefitsFailure(error));
      return { success: false, message: error };
    }
  };
};
